import React from 'react'
import { Layout } from '../../Components/Layout/Layout'
import Helpers from '../../Components/Helpers/Helpers'
import { useParams } from 'react-router-dom/cjs/react-router-dom'


const AppLayoutPublic = ({ title, children, page, showBread, hideTop, type }) => {
  const Logo = Helpers.config.resourcesUrl({ url: '/images/dashboard/logo.png' })
  const { idCustomers } = useParams();

  return <Layout
    resizeNav
    imageLogo={Logo}
    permissions={type === 'ecommerce_publico' ? [
      {
        parent: {
          description: 'Ingresar Pedido',
        },
        childrens: [
          {
            parent: {
              icon: 'fa fa-shopping-cart',
              description: 'Ingresar Pedido',
            },
            childrens: [
              {
                description: 'Ecommerce',
                a_href: 'ecommerce-publico/' + idCustomers,
                show: 1
              }
            ]
          }
        ]
      }
    ] : [
      {
        parent: {
          description: 'Cliente',
        },
        childrens: [
          {
            parent: {
              icon: 'fa fa-user',
              description: 'Cliente',
            },
            childrens: [
              {
                description: 'Alta de Cliente',
                a_href: 'alta-de-cliente',
                show: 1
              }
            ]
          }
        ]
      }
    ]}
    title={'Ecommerce Publico'}
    page={type === 'ecommerce_publico' ? 'ecommerce-publico/' + idCustomers : 'alta-de-cliente'}
    companyName={Helpers.config.company.name}
    folderPath={Helpers.config.convertUrl({ url: type === 'ecommerce_publico' ? '/ecommerce-publico/' + idCustomers : 'alta-de-cliente' })}
    showBread={false}
    hideTop
  >
    {children}
  </Layout>
}

export default AppLayoutPublic